import { ClipboardList } from "lucide-react";

const ACTIVITY_LABELS = {
  sedentary: "Sedentario",
  light: "Leggero",
  moderate: "Moderato",
  active: "Attivo",
};

export const QuestionnairesList = ({ questionnaires }) => (
  <div data-testid="questionnaires-list">
    <h2 className="font-serif text-xl text-stone-900 mb-6">Questionari Iniziali ({questionnaires.length})</h2>
    <div className="space-y-4">
      {questionnaires.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-2xl border border-stone-100">
          <ClipboardList className="w-12 h-12 text-stone-200 mx-auto mb-4" />
          <p className="text-stone-500">Nessun questionario compilato</p>
        </div>
      ) : (
        questionnaires.map((q) => (
          <div key={q.id} className="bg-white rounded-2xl p-6 border border-stone-100" data-testid={`questionnaire-row-${q.patient_email}`}>
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="font-medium text-stone-900">{q.patient_name}</h3>
                <p className="text-sm text-stone-500">{q.patient_email}</p>
              </div>
              <span className="text-[11px] px-2.5 py-1 rounded-full bg-[#e8ece6] text-[#2c4c3b] font-medium">
                {ACTIVITY_LABELS[q.activity_level] || q.activity_level}
              </span>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm">
              <div className="bg-[#f5f2ec] rounded-xl p-3">
                <p className="text-[10px] uppercase tracking-wider text-stone-500 mb-1">Tipo di dolore</p>
                <p className="text-stone-700">{q.pain_type}</p>
              </div>
              <div className="bg-[#f5f2ec] rounded-xl p-3">
                <p className="text-[10px] uppercase tracking-wider text-stone-500 mb-1">Obiettivo</p>
                <p className="text-stone-700">{q.goal}</p>
              </div>
              <div className="bg-[#f5f2ec] rounded-xl p-3">
                <p className="text-[10px] uppercase tracking-wider text-stone-500 mb-1">Attrezzatura</p>
                <p className="text-stone-700">{q.equipment}</p>
              </div>
            </div>
            {q.extra_notes && (
              <p className="text-sm text-stone-500 italic mt-3">Note: {q.extra_notes}</p>
            )}
          </div>
        ))
      )}
    </div>
  </div>
);

export default QuestionnairesList;
